<template>
  <div>
    <p class="text-align-justify">
      This page displays the briefings and After Action Reports of the mission "{{ mission_name }}".
      Here members can create and edit Reports.
    </p>
    <p class="text-align-justify">
      On the left you have a side menu to select the briefings for all factions that took part in this mission. Depending
      on the status of the mission and your membership status, some briefings might not be readable to you.
    </p>
    <p class="text-align-justify">
      Below the briefings you’ll find a list of all units that took part in this mission. Click on the + and - buttons of
      each unit to unfold and fold the unit structure. Click on the units to access a list of submitted Reports for that unit.
      The buttons for the Reports in the side menu are grey for Reports that are pending
      approval. Reports that are approved will show up green with a check mark.
    </p>
    <p class="text-align-justify">
      Click on ‘Add New Report’ to create a new Report for "{{ mission_name }}". NOTE: This will create a new AAR! To edit an
      already existing Report you need to select the Report first, then you click on the ‘Edit report’ button in the upper right
      of the report document.
    </p>
  </div>
</template>

<script>


export default {
  name: "MissionLobbyHelp",
  props: {
    mission_name: {
      type: String,
      default: "this mission"
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/campaign/MissionLobbyHelp.vue